(function() {
	'use strict';

/* -- Variables -- */

	const ranges = {jobless: [10,14,18,22,26],
									college: [15,20,25,30,35],
									manufacturing: [10,20,30,40,50]};

/* -- Function -- */

	// Set the innerHTML property of a node, ensuring that whitespace is preserved even in IE8.
	function setInnerHTML(node, html) {
		// IE does not have innerHTML for SVG nodes, so instead we inject the
		// new markup in a temp node and then move the child nodes across into
		// the target node
		const reusableSVGContainer = document.createElement('div');
		reusableSVGContainer.innerHTML = `<svg>${html}</svg>`;
		const svgNode = reusableSVGContainer.firstChild;
		return node.appendChild(svgNode.firstChild);
	}

	// Colour each PUMA on the map based on type and period
	function colourMap(map, type, period) {
		const pumas = bi_data[type][period];
		const range = ranges[type];

		// Go trough each PUMA
		let mapPuma, colour, value;
		for (const puma in pumas) {

			value = pumas[puma];

			if (value < range[0]) colour = 0;
			if (value >= range[0] && value < range[1]) colour = 1;
			if (value >= range[1] && value < range[2]) colour = 2;
			if (value >= range[2] && value < range[3]) colour = 3;
			if (value >= range[3] && value < range[4]) colour = 4;
			if (value >= range[4]) colour = 5;

			// Get the county on the appropriate map
			mapPuma = map.querySelector('#puma-'+puma);

			// then give it the proper colour
			if (null !== mapPuma && '' !== colour) {
				mapPuma.setAttribute('class','colour-'+colour);
				// mapPuma.setAttribute('fill',colours[colour]);
				// mapPuma.setAttribute('title','value= '+value);
			}
		}
	}

	// Show the maps and hide the placeholder
	function showMaps() {
		[].slice.call(document.querySelectorAll('.bh__map')).forEach(function(x) {
			x.querySelector('.bh__map__placeholder').classList.add('bh__map--hidden');
			x.querySelector('.bh__map__svg').setAttribute('class','bh__map__svg');
		});
	}

	function createMap(type, period) {

		// Get the accurate container
		const container = document.querySelector(`.bh__container--${type} .bh__map--${period} .bh__map__svg`);

		// Add an SVG map to it
		const svg = period !== '1980' ? bi_svg_2015 : bi_svg_1980;
		const map = setInnerHTML(container, svg)

		// Hide the map before it is coloured
		// map.setAttribute('class','bh__map__svg bh__map--hidden');

		// Colour the map
		colourMap(map, type, period);

		// Append it to the appropriate container
		container.appendChild(map);
	}

/* -- Application -- */

	// Run the whole damn thing
	function app() {

		// Let's add all the maps based on the data
		/*
			{
				"jobless": { 					// Type
					"1980": {  					// Period
						"1": xxxx,				// PUMA
						"2": xxxx,				// PUMA
						[...]
					}, [...]
				}, [...]
			}

		 */
		for(const type in bi_data) {
			for(const period in bi_data[type]) {
				createMap(type, period);
			}
		}

		// Reveal the maps by hidding the placeholders
		showMaps();
	}

	// Start the whole thing when the DOM is complete
	document.addEventListener('readystatechange', function() {
		document.readyState === 'interactive' && app();
	}, false);

// end of the interactive
})();

